import Product from './CartProduct';

export default Product;
